import React, {Component} from 'react';
import {Box} from "@material-ui/core";
import {Logo, Title} from "./styled";
import logo from "../../../Assets/logo_login.png";

class StaticElementForgotPasswordScreen extends Component {
    render() {
        return (
            <div>
                <Box display={'flex'}
                     justifyContent={'center'}>
                    <Logo src={logo}/>
                </Box>
                <br/>
                <Title variant={'h6'}
                       align={'center'}
                       color={'primary'}>
                    Deixe seu email abaixo e enviaremos um link para redefinição da sua senha.
                </Title>
            </div>
        );
    }
}

export default StaticElementForgotPasswordScreen;